module.exports = __webpack_public_path__ + "img/SUMMERGATE.e1f292e4.png";